export default __webpack_public_path__ + "static/media/envelopeMoney.c1911492.jpg";